import * as React from 'react';
import { useSelector } from 'react-redux';

import { NewbuildingConsultBannerContainer } from '../NewbuildingConsultBanner';
import { BrokerBannerContainer } from './BrokerBannerContainer';
import { isDiscountMortgageBannerEnabled } from '../../selectors/discountMortgage';
import { DiscountMortgageBannerContainer } from '../DiscountMortgageBannerContainer';
import { INewbuilding } from '../../types/newbuilding';
import { getNewbuildingBrokerEnabled } from '../../selectors/broker';

interface IBannerContainerProps {
  newbuilding: INewbuilding;
}

export const BannerContainer: React.FC<IBannerContainerProps> = ({ newbuilding }) => {
  const isBrokerBannerAvailable = getNewbuildingBrokerEnabled(newbuilding);
  const isDiscountMortgageBannerAvailable = useSelector(isDiscountMortgageBannerEnabled);

  if (isDiscountMortgageBannerAvailable) {
    return <DiscountMortgageBannerContainer />;
  }

  if (isBrokerBannerAvailable) {
    return <BrokerBannerContainer />;
  }

  return <NewbuildingConsultBannerContainer />;
};
